const AppConstants = {
  OTP_ATTEMP_LIMIT: 3,
  APP_URL: window.location.origin,

  routes: {
    home: '/',
    home2: '/:isoCode([A-Za-z]{2})',
    about: '/about-us',
    login: '/login',
    // password: '/reset-password',
    forgotPassword: '/reset-password',
    register: '/register',
    afterLogin: '/match-queue',
    publicProfile: '/public-profile',
    editProfile: '/edit-profile',
    chat: '/chat',
    editProfilePhotos: '/edit-profile-photos',
    settings: '/settings',
    plansView: '/plan-view',
    billingDetails: '/billing-details',
    plans: '/plans',
    rosePlans: '/rose-plans',
    likesPlans: '/likes-plans',
    order: '/order',
    matchQueue: '/my-matches',
    contact: '/contact-us',
    faq: '/faq',
    viewProfile: '/view-profile',
    viewProfilePhotos: '/view-profile-photos',
    registerSuccess: '/register-success',
    registerSections: '/register-sections',
    congratulations: '/congratulations',
    accountSuccess: '/account-success',
    profileSection1: '/profile-section1',
    section1Success: '/section1-success',
    profileSection2: '/profile-section2',
    roseHistory: '/rose-history',
    likeHistory: '/like-history',
    gift: '/gift',
    beAMatchmaker: '/be-a-matchmaker',
    affiliate: {
      home: '/affiliate',
      accountType: '/affiliate/account-type',
      register: '/affiliate/register',
      registerSection: '/affiliate/register-sections',
      login: '/affiliate/login',
      dashboard: '/affiliate/dashboard',
      referals: '/affiliate/referals',
      earnings: '/affiliate/earnings',
      payments: '/affiliate/payments',
      profile: '/affiliate/profile',
      settings: '/affiliate/settings',
      contactsUs: '/affiliate/contacts',
      conditionOfUse: '/affiliate/condition-of-use',
      privacyPolicy: '/affiliate/privacy-policy',
      associatesProgramPolicies: '/affiliate/associates-program-policies',
      associatesProgramOperatingAgreement: '/affiliate/associates-program-operating-agreement',
    },
    affiliateSteps3: '/affiliate-steps3',
    AffiliateRegSuccess: '/affiliate-Success',
    emailVerification: '/email-verify',
    rewardFeedbacks: '/reward-feedback',
    feedbacks: '/feedbacks',
    unsubscribe: '/unsubscribe/:token',
    payPalCheckout: "/paypal-checkout",
    paymentSuccess: "/payment-success",
    paymentFail: "/payment-fail",
    admin: {
      login: '/admin/login',
      dashboard: '/admin/recent-profiles/',
      premium_profiles: '/admin/premium-profiles/',
      all_profiles: '/admin/all-profiles/',
      approved_profiles: '/admin/approved-profiles/',
      suspended_profiles: '/admin/suspended-profiles/',
      hidden_profiles: '/admin/hidden-profiles/',
      rejected_profiles: '/admin/rejected-profiles/',
      deleted_profiles: '/admin/deleted-profiles/',
      requested_info_profiles: '/admin/requested-info-profiles/',
      affiliate: {
        payments: {
          summary: '/admin/affiliate/payment-summary',
          overdue: '/admin/affiliate/payment-overdue',
          upcoming: '/admin/affiliate/payment-upcoming',
          future: '/admin/affiliate/payment-future',
          paid: '/admin/affiliate/payment-paid',
        },
        recent_profiles: '/admin/recent-profiles/affiliate',
        requested_info_profiles: '/admin/requested-info-profiles/affiliate',
        all_profiles: '/admin/all-profiles/affiliate',
        approved_profiles: '/admin/approved-profiles/affiliate',
        suspended_profiles: '/admin/suspended-profiles/affiliate',
        deleted_profiles: '/admin/deleted-profiles/affiliate',
        rejected_profiles: '/admin/rejected-profiles/affiliate',
      }
    },
    matchQueueCountryPreference: '/match-queue/country-preference',
  },
  PAGINATION: {
    term: '',
    page: 1,
    limit: 10
  },
  COUNTRIES_TO_REMOVE_ARR: ["AX", "AS", "AI", "AQ", "AW", "BV", "IO", "KY", "CX", "CC", "CK", "FK", "FO", "GF", "PF", "TF", "GI", "GL", "GP", "GU", "GG", "HM", "JE", "MO", "IM", "MQ", "YT", "MS", "BQ", "NC", "NU", "NF", "MP", "PS", "PN", "PR", "RE", "SH", "PM", "BL", "MF", "GS", "SJ", "TK", "TC", "UM", "VA", "VG", "VI", "WF", "EH", "CW", "SX"],

  USER_APPROVAL_PREMIUM_PLAN_DURATION: '3 Days',

  DRINKING_LEVEL_ARR: ['Never', 'Occasionally', 'Daily'],

  SMOKING_LEVEL_ARR: ['Never', 'Occasionally', 'Daily'],

  MATCH_QUEUE_FILTERS: {
    age: {
      min: null,
      max: null
    },
    residence_states: [],
    origin_countries: [],
    origin_states: [],
    cultural_groups: [],
    cultural_sub_groups: [],
    height: {
      min: null,
      max: null
    },
    love_goals: [],
    min_education_level: null,
    occupations: [],
    match_values: [],
    smoking_status: null,
    drinking_status: null,
    hobbies: []
  },
  ADMIN_FILTER_DEFAULT_VALUES: {
    name: '',
    email: '',
    phone_no: '',
    country: '',
    state: '',
    city: '',
    educationLevel: '',
    occupation: '',
    originCountry: '',
    originState: '',
    originCity: '',
    registrationDate: '',
    userId: '',
    hasPhoto: '',
    hasPhoneNo: '',
    hasLinkedinUrl: '',
    hasAboutMe: '',
    hasLookingFor: '',
    hasActiveSubscription: '',
    salaryRange: { min: 0, max: 500 },
    ageRange: { min: 18, max: 75 },
    accountDeletionReason: ''
  }
};

export default AppConstants;
